import { faChevronDown } from "@jewlr/pro-regular-svg-icons/faChevronDown"
import { faChevronUp } from "@jewlr/pro-regular-svg-icons/faChevronUp"
import PropTypes from "prop-types"
import { useState } from "react"
import { connect } from "react-redux"

import {
  ItemAction,
  ItemTitle,
  ShadowBox,
  DetailText,
  RetailPrice,
} from "areas/cart/components"
import { removeAddon } from "areas/cart/store/actions"
import Confirmation from "components/ui/confirmation"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import Image from "components/ui/image"
import { jewlr_t } from "helpers/application"
import { to_currency } from "helpers/number"
import { cn } from "styles/utils"

const InternalAddonDesktopItem = ({ addon, index, deleteExclusiveAddon }) => {
  const [showAddonDetail, toggleAddonDetail] = useState(false)
  const [showRemoveItemDialog, toggleRemoveItemDialog] = useState(false)
  return (
    <ShadowBox
      data-cy={`cart-addon-desktop-${index}-${addon.addon_code}`}
      data-ge-basket-cartitemid={addon.id}
      id={"addon_item_" + addon.id}
      key={`d_addon-${addon.id}`}
    >
      <div className="flex gap-10" data-cy="cart-addons">
        <Image
          alt={addon.title}
          height="128px"
          src={addon.image_url}
          title={addon.title}
          width="128px"
        />
        <div className="flex-1">
          <ItemTitle className="mb-12">{addon.title}</ItemTitle>
          <ItemAction
            data-cy={`cart-addon-remove-btn-desktop-${index}-${addon.addon_code}`}
            onClick={() => toggleRemoveItemDialog(true)}
          >
            Remove
          </ItemAction>
          <ItemAction
            aria-controls={`cart-addon-details-desktop-${addon.id}`}
            aria-expanded={showAddonDetail}
            onClick={() => {
              toggleAddonDetail(!showAddonDetail)
            }}
          >
            View Item Details{" "}
            <FontAwesomeIcon
              className="text-8 align-text-bottom"
              icon={showAddonDetail ? faChevronUp : faChevronDown}
            />
          </ItemAction>
          <Expand
            id={`cart-addon-details-desktop-${addon.id}`}
            show={showAddonDetail}
          >
            <DetailText>{addon.description}</DetailText>
          </Expand>
        </div>
        <div className="text-right">
          <p
            className={cn(
              "text-32 font-light",
              addon.price == 0.0 ? "text-green-darker" : "text-sale"
            )}
          >
            {addon.price == 0.0 ? "FREE" : to_currency(addon.price)}
          </p>
          <RetailPrice>
            <strike>{to_currency(addon.retail_price)}</strike>
          </RetailPrice>
        </div>
      </div>
      <Confirmation
        cancelText="Cancel"
        confirmText="Yes"
        description={`Are you sure you want to remove this item from your ${jewlr_t("Cart")}?`}
        modalType="popup"
        onCancel={() => toggleRemoveItemDialog(false)}
        onConfirm={() => {
          deleteExclusiveAddon(addon.id)
          toggleRemoveItemDialog(false)
        }}
        show={showRemoveItemDialog}
        title="Remove Item"
      />
    </ShadowBox>
  )
}

InternalAddonDesktopItem.propTypes = {
  addon: PropTypes.object,
  deleteExclusiveAddon: PropTypes.func,
  exclusiveAddonsRef: PropTypes.func,
  index: PropTypes.number,
}

const mapStateToProps = (state) => {
  return {
    addons: state.cart.addons.filter(
      (a) => a.addon_type === "BUNDLE" || a.addon_type === "GIFT_CARD"
    ),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    deleteExclusiveAddon: (addon_id) => {
      dispatch(removeAddon(addon_id))
    },
  }
}

const AddonDesktopItem = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalAddonDesktopItem)

export default AddonDesktopItem
